module.exports = __webpack_public_path__ + "img/ic_delivery.5ef4cc5d.svg";